import { configureStore, combineReducers, createAction, AnyAction } from '@reduxjs/toolkit';

import userReducer from './reducers/user';
import promotionsReducer from './reducers/promotions';

export const allReducer = {
  user: userReducer,
  promotions: promotionsReducer,
};

export const rootReducer = combineReducers(allReducer);

export const resetSession = createAction('session/reset');

export const appReducer = (state: ReturnType<typeof rootReducer> | undefined, action: AnyAction) =>
  rootReducer(resetSession.match(action) ? undefined : state, action);

const store = configureStore({
  reducer: appReducer
});

export default store;
